import { createActionGroup, emptyProps } from "@ngrx/store";

import { ActionSource } from "../../state/action-sources";

export const JobDocumentsActions = createActionGroup({
  source: ActionSource.JOB_DOCUMENTS,
  events: {
    'Create Document Button Clicked': emptyProps(),
    'Upload Document Button Clicked': emptyProps(),
  },
});
